import React, { useEffect } from "react";
import "./DutyFreeCopilotPage.css";
import { KODLY_WIDGET_ORIGIN } from "./kodlyWidgetOrigin";

// Staff copilot demo for duty free shops at Italian airports (EDG Advisoring,
// October 2026). Its own chat in the "Duty Free Demo" tenant on Kodly-hosted
// QA, booted docked like the operators-ui does for Radio Popular's staff.
// The token is public by design, as in the Salsa pages under public/.
const WIDGET_TOKEN = "pk_kodly_live_T_K3gQVnpI89q_m1d5INSLOu1m9Wc0PD";
const CONTAINER_ID = "duty-free-copilot-chat";
const SHOPS = ["BLQ", "BRI", "TRN", "SUF", "FCO"];

function DutyFreeCopilotPage() {
  useEffect(() => {
    document.title = "Staff Assistant · Duty Free demo";

    if (document.getElementById("kodly-ai-agent-loader")) return undefined;

    // The widget ships no Italian chrome, so the buttons and placeholder are in
    // English; the agent still answers in the language each message is written in.
    const url = new URL(`${KODLY_WIDGET_ORIGIN}/loader.js`);
    url.searchParams.set("token", WIDGET_TOKEN);
    url.searchParams.set("mode", "docked");
    url.searchParams.set("container", CONTAINER_ID);
    url.searchParams.set("language", "en");

    const script = document.createElement("script");
    script.id = "kodly-ai-agent-loader";
    script.src = url.toString();
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return (
    <div className="dfc-page">
      <header className="dfc-header">
        <div className="dfc-brand">
          <span className="dfc-mark" aria-hidden="true" />
          <div>
            <div className="dfc-title">Staff Assistant</div>
            <div className="dfc-subtitle">Duty free shops · Italian airports</div>
          </div>
        </div>
        <div className="dfc-meta">
          <ul className="dfc-shops" aria-label="Shops">
            {SHOPS.map((shop) => (
              <li key={shop}>{shop}</li>
            ))}
          </ul>
          <span className="dfc-demo">Demo</span>
        </div>
      </header>
      <main className="dfc-main">
        <div id={CONTAINER_ID} className="dfc-chat" />
      </main>
      <footer className="dfc-footer">
        Sample catalogue, stock, procedures and campaigns for demonstration
      </footer>
    </div>
  );
}

export default DutyFreeCopilotPage;
